/* eslint-disable */

import React, { Component } from 'react';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import * as AppActions from '../../actions';
import { bindActionCreators } from 'redux';
import { compose, graphql, withApollo } from 'react-apollo';
import update from 'react-addons-update';
import _ from 'lodash';

import './AdBlueprintSearch.css';
import AdBlueprintList from './AdBlueprintList';
import { getAccounts } from '../../services/AccountService';
import { getPages } from '../../fbApi/Page';
import { creds } from '../../config/FBAdOps';
import AdBlueprintBuilder from './AdBlueprintBuilder';
import { getCarousels } from '../../services/CarouselService';
import * as AdBlueprintDB from '../../database/AdBlueprintDB';

class AdBlueprintSearch extends Component {
  state = {
    token: this.props.getFbToken(),
    section: 'search',
    accountOptions: [],
    carousels: [],
    pages: [],
    carouselsOptions: []
  };

  componentDidMount() {
    this.props.setSectionTitle('Ad Blueprint');
    this.props.saveGTMEvent('Ad Blueprint', 'Ad Blueprint');
    this.getAdAccounts();
    this.getCarousels();
    this.getPages();
  }

  getCarousels = async () => {
    const carousels = await getCarousels();
    const carouselsOptions = _.sortBy(
      _.map(carousels.carousels, (op, index) => ({
        key: index,
        value: op.id,
        text: op.name
      })),
      'text'
    );

    this.setState({ carouselsOptions, carousels: carousels.carousels });
  };

  getPages = async () => {
    const pages = await getPages(this.state.token);
    const pageOptions = _.sortBy(
      _.map(pages[0].data.concat(pages[1].data), (op, index) => ({
        key: index,
        value: op.id,
        text: op.name
      })),
      'text'
    );
    this.setState({ pages: pageOptions });
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        accountOptions
      });
    } catch (error) {
      alert(error);
    }
  };

  componentWillReceiveProps = (nextProps) => {
    this.props.data.refetch();
  };

  newAdBlueprint = () => {
    this.setState({ section: 'newAdBlueprint', adBlueprintToEdit: null });
  };

  searchPage = () => {
    this.getCarousels();
    this.setState({ section: 'search' });
    this.props.data.refetch();
  };

  deleteAdBlueprint = async (id) => {
    await this.props.deleteAdBlueprint(id);
    this.props.data.refetch();
  };

  editAdBlueprint = (id) => {
    const adBlueprint = this.props.data.adBlueprints.list.find(
      (blueprint) => blueprint.id === id
    );
    this.setState({
      section: 'newAdBlueprint',
      adBlueprintToEdit: adBlueprint
    });
  };

  render() {
    const { data } = this.props;
    if (!this.props.data.loading) {
      return (
        <div className="container">
          {this.state.section === 'search' ? (
            <AdBlueprintList
              pages={this.state.pages}
              adBlueprints={data}
              accounts={this.state.accountOptions}
              deleteAdBlueprint={this.deleteAdBlueprint}
              newAdBlueprint={this.newAdBlueprint}
              getFbToken={this.props.getFbToken}
              editAdBlueprint={this.editAdBlueprint}
            />
          ) : null}
          {this.state.section === 'newAdBlueprint' ? (
            <AdBlueprintBuilder
              carousels={this.state.carousels}
              carouselsOptions={this.state.carouselsOptions}
              pages={this.state.pages}
              accounts={this.state.accountOptions}
              searchPage={this.searchPage}
              getFbToken={this.props.getFbToken}
              adBlueprintToEdit={this.state.adBlueprintToEdit}
            />
          ) : null}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

const withAdBlueprintList = compose(
  graphql(AdBlueprintDB.adBlueprintQuery),
  graphql(AdBlueprintDB.deleteAdBlueprint, {
    props: ({ mutate }) => ({
      deleteAdBlueprint: (id) =>
        mutate({
          variables: { id },
          updateQueries: {
            getAllAdBlueprints: (prev) => {
              const adBlueprintList = prev.adBlueprints.list.map(
                (item) => item
              );
              const deleteIndex = _.findIndex(
                adBlueprintList,
                (item) => item.id === id
              );
              if (deleteIndex < 0) {
                return prev;
              }
              return update(prev, {
                adBlueprints: {
                  list: {
                    $splice: [[deleteIndex, 1]]
                  }
                }
              });
            }
          }
        })
    })
  })
);

const ListWithData = withAdBlueprintList(AdBlueprintSearch);

export default withApollo(
  connect(mapStateToProps, mapDispatchToProps)(ListWithData)
);



// WEBPACK FOOTER //
// ./src/screens/AdBlueprint/AdBlueprintSearch.js